export default __webpack_public_path__ + "e7e65dfbfd93280ed1091e31370a5881.woff";